import domReady from '@wordpress/dom-ready';

domReady(() => {
  const btns = document.querySelectorAll(
    'body:not(.microsite-page) .btn, body:not(.microsite-page) .wp-block-button:not(.is-style-pdf-link):not(.is-style-external-link) .wp-element-button'
  );

  if (btns) {
    btns.forEach((button) => {
      const parent = button.closest('.wp-block-button');
      if (
        parent &&
        (parent.classList.contains('is-style-btn-member-area') ||
          (parent && parent.classList.contains('is-style-become-member')))
      ) {
        button.innerHTML =
          '<span class="btn-icon"><svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon-membre"><path id="Vector" d="M20.9527 38.073C17.4228 35.892 15.0653 31.9964 15.0653 27.5336C15.0653 20.688 20.6123 15.1409 27.4579 15.1409H27.584L27.5966 0C12.317 0.226925 0 12.67 0 28C0 36.4467 3.74426 44.0109 9.65691 49.1419C11.6362 44.0109 15.7713 39.9514 20.9527 38.0604V38.073Z" fill="#E7332F"/><path id="Vector_2" d="M27.4704 15.1411C20.6249 15.1411 15.0778 20.6882 15.0778 27.5337C15.0778 31.984 17.4353 35.8795 20.9652 38.0732C15.7838 39.9516 11.6487 44.011 9.66943 49.1547C14.4853 53.3402 20.7509 55.8994 27.6091 56.0002V15.1537H27.483L27.4704 15.1411Z" fill="#AD0830"/><path id="Vector_3" d="M28 0C27.8613 0 27.7352 0 27.5966 0V15.1409C34.3791 15.204 39.8631 20.7258 39.8631 27.5336C39.8631 31.9838 37.5056 35.8794 33.9757 38.073C39.384 40.0397 43.6578 44.3765 45.5236 49.8227C51.9027 44.6916 56 36.8249 56 28C56 12.5313 43.4687 0 28 0Z" fill="#AD0830"/><path id="Vector_4" d="M33.9757 38.0732C37.5056 35.8922 39.8631 31.9966 39.8631 27.5337C39.8631 20.726 34.3791 15.2168 27.5966 15.1411V55.9876C27.7352 55.9876 27.8613 55.9876 28 55.9876C34.6312 55.9876 40.733 53.6679 45.5236 49.8102C43.6578 44.3514 39.384 40.0272 33.9757 38.0605V38.0732Z" fill="#E7332F"/></g></svg></span><span class="icon-label btn-label">' +
          button.innerHTML +
          '</span>';
      } else if (button.classList.contains('member-space__go-back-home')) {
        button.innerHTML =
          '<span class="icon icon-prompt_suggestion btn-icon"></span><span class="icon-label btn-label">' +
          button.innerHTML +
          '</span>';
      } else if (
        button.classList.contains('user-listing-block__add-user-btn')
      ) {
        button.innerHTML =
          '<span class="icon icon-add btn-icon"></span><span class="icon-label btn-label">' +
          button.innerHTML +
          '</span>';
      } else if (button.classList.contains('js-profile-edit-start')) {
        button.innerHTML =
          '<span class="icon icon-edit_document btn-icon"></span><span class="icon-label btn-label">' +
          button.innerHTML +
          '</span>';
      } else if (button.classList.contains('js-profile-edit-save')) {
        button.innerHTML =
          '<span class="icon icon-save btn-icon"></span><span class="icon-label btn-label">' +
          button.innerHTML +
          '</span>';
      } else if (button.classList.contains('js-profile-edit-cancel')) {
        button.innerHTML =
          '<span class="icon icon-icon-fermer btn-icon"></span><span class="icon-label btn-label">' +
          button.innerHTML +
          '</span>';
      } else {
        button.innerHTML =
          '<span class="icon icon-icon-arrow-A btn-icon"></span><span class="icon-label btn-label">' +
          button.innerHTML +
          '</span>';
      }

      const icon = button.querySelector('.btn-icon');
      const text = button.querySelector('.btn-label');

      if (icon && text) {
        button.addEventListener('mouseenter', () => {
          const iconWidth = icon.offsetWidth;
          const textWidth = text.offsetWidth;

          icon.style.transform = `translateX(${textWidth}px)`;
          text.style.transform = `translateX(-${iconWidth}px)`;
        });

        button.addEventListener('mouseleave', () => {
          icon.style.transform = `translateX(0)`;
          text.style.transform = `translateX(0)`;
        });
      }
    });
  }

  const btnsPDF = document.querySelectorAll(
    '.wp-block-button.is-style-pdf-link .wp-element-button'
  );

  if (btnsPDF) {
    btnsPDF.forEach((buttonPDF) => {
      buttonPDF.innerHTML =
        '<svg width="19" height="26" viewBox="0 0 19 26" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon-pdf" clip-path="url(#clip0_685_1055)"><path id="Vector" d="M19 26H0V0H12.6903V6.39434H19V26Z" fill="#EF413A"/><path id="Vector_2" d="M12.6902 6.39434H18.9999L12.6902 0V6.39434Z" fill="#AD0830"/><path id="Vector_3" d="M15.843 20.603H2.98169V22.6697H15.843V20.603Z" fill="#AD0830"/><path id="Vector_4" d="M10.4341 18.2617V8.4314H8.39479V18.2617H10.4341Z" fill="#AD0830"/><path id="Vector_5" d="M10.857 18.0691L5.63452 12.7766L4.19253 14.2379L9.41497 19.5304L10.857 18.0691Z" fill="#AD0830"/><path id="Vector_6" d="M9.4133 19.5369L14.6357 14.2444L13.1937 12.783L7.97131 18.0755L9.4133 19.5369Z" fill="#AD0830"/></g><defs><clipPath id="clip0_685_1055"><rect width="19" height="26" fill="white"/></clipPath></defs></svg>' +
        buttonPDF.innerHTML;
    });
  }

  const btnsExternalLink = document.querySelectorAll(
    '.wp-block-button.is-style-external-link .wp-element-button'
  );

  if (btnsExternalLink) {
    btnsExternalLink.forEach((buttonExternalLink) => {
      buttonExternalLink.innerHTML =
        '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_685_1048)"><path d="M17.5197 4.43616H0V22.0052H17.5197V4.43616Z" fill="#EF413A"/><path d="M20.0158 0.205436L8.76001 11.4929L10.5407 13.2786L21.7965 1.99113L20.0158 0.205436Z" fill="#AD0830"/><path d="M19.4819 -1.43051e-05V9.146H22.0002V-1.43051e-05H19.4819Z" fill="#AD0830"/><path d="M22 0H12.8796V2.52535H22V0Z" fill="#AD0830"/></g><defs><clipPath id="clip0_685_1048"><rect width="22" height="22" fill="white"/></clipPath></defs></svg>' +
        buttonExternalLink.innerHTML;
    });
  }
});
